import { object, string } from "yup";

export const invoiceSettingValidation = (contextTitle: string) =>
  object({
    invoice_prefix: string().required(`${contextTitle} prefix is required`),
    entity_id: string().required("Entity selection is required"),
  });
